import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { DashboardPage } from "./dashboard.page";
import { DashboardPageRoutingModule } from "./dashboard-routing.module";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatLegacyListModule as MatListModule } from "@angular/material/legacy-list";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatIconModule } from "@angular/material/icon";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatLegacyFormFieldModule as MatFormFieldModule } from "@angular/material/legacy-form-field";
import { MatLegacyInputModule as MatInputModule } from "@angular/material/legacy-input";
import { MatLegacyButtonModule as MatButtonModule } from "@angular/material/legacy-button";
import { MatLegacyMenuModule as MatMenuModule } from "@angular/material/legacy-menu";
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from "@angular/material/legacy-progress-spinner";
import { SharedModule } from "@shared/shared.module";
import { LayoutModule } from "@angular/cdk/layout";
import { FlexLayoutModule } from "ngx-flexible-layout";
import { MatLegacyTooltipModule as MatTooltipModule } from "@angular/material/legacy-tooltip";
import { BreadcrumbsModule } from "@shared/components/breadcrumbs/breadcrumbs.module";
import { SideNavComponent } from "./_components/side-nav/side-nav.component";

@NgModule({
	declarations: [DashboardPage, SideNavComponent],
	imports: [
		BreadcrumbsModule,
		DashboardPageRoutingModule,
		CommonModule,
		SharedModule,
		MatSidenavModule,
		MatListModule,
		MatExpansionModule,
		MatIconModule,
		MatToolbarModule,
		MatFormFieldModule,
		MatInputModule,
		MatButtonModule,
		MatMenuModule,
		MatProgressSpinnerModule,
		LayoutModule,
		FlexLayoutModule,
		MatTooltipModule
	],
	exports: [DashboardPage, SideNavComponent]
})
export class DashboardPageModule {}
